import { render, staticRenderFns } from "./XRayDiffractionViz.vue?vue&type=template&id=01e27155&scoped=true"
import script from "./XRayDiffractionViz.vue?vue&type=script&lang=js"
export * from "./XRayDiffractionViz.vue?vue&type=script&lang=js"
import style0 from "./XRayDiffractionViz.vue?vue&type=style&index=0&id=01e27155&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e27155",
  null
  
)

export default component.exports